import React, { useState, useEffect } from 'react';
import { useNotification } from 'config/Notification';

import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import Modal from 'react-bootstrap/Modal';

import { downloadReport as downloadReportService, fetchReports as fetchPDFReportsService } from 'services/modules/vapt/report';

const ViewReportPage = ({ toggleViewReport }) => {
  // State variables
  const [loading, setLoading] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [show, setShow] = useState(true);
  const [error, setError] = useState('');
  const [reportsData, setReportsData] = useState([]);

  // Notification
  const { openNotification } = useNotification();

  // This method fetches all the report ids of completed status
  const fetchReportsData = async () => {
    setLoading(true);
    const params = {
      reportStatus: 'COMPLETED',
      limit: 'null'
    };
    try {
      const response = await fetchPDFReportsService(params)
      if (response?.status === 200)
        setReportsData(response?.data)
      else
        openNotification(response)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // This method handles downloading the reports in excel format
  const handleDownloadExcel = async () => {
    try {
      if (!selectedReportId) {
        setError('Please select a report ID');
        return;
      }
      const response = await downloadReportService(selectedReportId);
      if (response.status === 200) {
        const fileUrl = response.data.url;
        window.open(fileUrl, '_blank');
      } else {
        openNotification(response, 'error');
      }
    } finally {
      setShow(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90w"
      animation={false}
    >
      <Modal.Header className="space-between" closeButton>
        <Modal.Title  className="report-modal">
          <LibraryBooksIcon className="m-1" />
          <h4 className="report-heading-1">Request VAPT Excel Report</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className="report-label mt-4">
          Receive an excel version of the report generated for your domain
        </h5>

        {loading ? (
          <div className="loader-container">
             <CircularProgress size={24} color="inherit" /> 
          </div>
        ) : (
          <>
            <div className="report-modal-buttons">
              <FormControl style={{ width: '70%' }}>
                <InputLabel>Report Id</InputLabel>
                <Select
                  label="Report ID"
                  value={selectedReportId}
                  onBlur={() => {
                    if (!selectedReportId) {
                      setError('Please select a report ID');
                    } else {
                      setError('');
                    }
                  }}
                  onChange={(e) => setSelectedReportId(e.target.value)}
                >
                  {reportsData?.results?.length === 0 && <MenuItem disabled>No data found</MenuItem>}
                  {reportsData?.results?.map((report, index) => (
                    <MenuItem key={index} value={report.id}>
                      {report.reportId}
                    </MenuItem>
                  ))}
                </Select>
                {error && <FormHelperText error>{error}</FormHelperText>}
              </FormControl>
            </div>
            <div className="report-modal-buttons">
              <Button variant="outlined" className="exel-button" onClick={handleDownloadExcel}>
                <LibraryBooksIcon className="m-1" /> Download Excel
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewReportPage;
